import ModalStack from '@/components/Custom/ModalStack';

export const unstable_settings = {
  anchor: 'index',
};

export default function PrivateBadgeBadgeIdLayoutRoute() {
  return <ModalStack />;
}
